<script>
  import { onMount } from 'svelte';
  import { MDCDrawer } from '@material/drawer';
  import { MDCTopAppBar } from '@material/top-app-bar';
  import router from '../../lib/router';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session';
  import settings from '../../config';
  import APIClient from '../../state-charts/api-client';
  import GoogleAnalytics from '../GoogleAnalytics.svelte';
  import Notifications from './components/Notifications.svelte';
  import Messages from '../../lib/components/Messages.svelte';
  import Dialog from '../../lib/components/Dialog.svelte';
  import SupportButton from './components/SupportButton.svelte';
  import { show_message } from '../../lib/flash';
  import { chat_count } from '../../chat/unread_chats_count.js';

  export let route_name;
  export let hide_scrollbar = false;

  let current_route = '/home';
  let menu_opened = false;
  let merchant_uuid;
  let merchant;
  let merchant_style;
  let is_powered_by = false;
  let avatar;
  let username;
  let cv_url = '/cv';
  let is_admin = false;
  let has_init = false;
  let orderer_menu_items = [];
  let worker_menu_items = [];

  let no_content;
  let cv_sharing_not_allowed_title;
  let cv_sharing_not_allowed_message;
  let menu_label_home;
  let menu_label_orders;
  let menu_label_chat;
  let menu_label_my_teams;
  let menu_label_workers_map;
  let menu_label_pilot_points;
  let menu_label_public_profile;
  let menu_label_settings;
  let menu_label_payment_methods;
  let menu_label_reports;
  let menu_label_tou;
  let menu_label_logout;
  let menu_label_support;
  let menu_label_cv;
  let menu_label_mode_orderer;
  let menu_label_mode_worker;
  let menu_label_switch_service;
  let menu_label_service_admin;
  let ok_button;
  let menu_items;
  let menu_label_invite;
  let menu_label_documents;
  let button_disabled = false;

  const translate_texts = () => {
    ok_button = t9n(TS.REG_FORM_OK);
    menu_label_chat = t9n(TS.TABLE_HEADER_CHAT);
    menu_label_home = t9n(TS.MENU_LABEL_HOME);
    menu_label_orders = t9n(TS.MENU_LABEL_ORDERS);
    menu_label_my_teams = t9n(TS.MENU_LABEL_MY_TEAMS);
    menu_label_workers_map = t9n(TS.MENU_LABEL_WORKERS_MAP);
    menu_label_pilot_points = t9n(TS.MENU_LABEL_PILOT_POINTS);
    menu_label_public_profile = t9n(TS.MENU_LABEL_PUBLIC_PROFILE);
    menu_label_settings = t9n(TS.MENU_LABEL_SETTINGS);
    menu_label_payment_methods = t9n(TS.PAYMENT_AND_REPORTS);
    menu_label_reports = t9n(TS.MENU_LABEL_REPORTS);
    menu_label_tou = t9n(TS.MENU_LABEL_TERMS);
    menu_label_invite = t9n(TS.MENU_LABEL_INVITE);
    menu_label_logout = t9n(TS.MENU_LABEL_LOGOUT);
    menu_label_support = t9n(TS.MENU_LABEL_SUPPORT);
    menu_label_cv = t9n(TS.MENU_LABEL_CV);
    menu_label_mode_orderer = t9n(
      TS.MENU_LABEL_MODE_ORDERER,
      merchant_specific_words('orderer')
    );
    menu_label_mode_worker = t9n(
      TS.MENU_LABEL_MODE_WORKER,
      merchant_specific_words('worker')
    );
    menu_label_service_admin = t9n(TS.MENU_LABEL_SERVICE_ADMIN);
    menu_label_documents = t9n(TS.DOCUMENTS_NAME);
    no_content = t9n(TS.MENU_NO_CONTENT);
    cv_sharing_not_allowed_title = t9n(
      TS.PROFILE_PUBLIC_SHARING_NOT_ALLOWED_TITLE
    );
    cv_sharing_not_allowed_message = t9n(
      TS.PROFILE_PUBLIC_SHARING_NOT_ALLOWED_MESSAGE
    );
    menu_label_switch_service = t9n(TS.MENU_LABEL_SWITCH_SERVICE);

    orderer_menu_items = [
      { name: menu_label_home, icon: 'home', route: '/home', internal: true },
      {
        name: menu_label_orders,
        icon: 'file_copy',
        route: '/orders',
        internal: true,
      },
      {
        name: menu_label_chat,
        icon: 'chat_bubble',
        route: '/chats',
        internal: true,
      },
      {
        name: menu_label_payment_methods,
        icon: 'payment',
        route: '/cards',
        internal: true,
      },

      {
        name: 'menu_section_line',
      },

      {
        name: menu_label_settings,
        icon: 'settings',
        route: '/settings',
        internal: true,
      },
      {
        name: menu_label_public_profile,
        icon: 'person',
        route: '/profile',
        internal: true,
      },
      {
        name: menu_label_my_teams,
        icon: 'people_alt',
        route: '/orderer-teams',
        internal: true,
      },

      {
        name: 'menu_section_line',
      },

      {
        name: menu_label_workers_map,
        icon: 'public',
        route: `/workers-map`,
        internal: true,
      },
      {
        name: menu_label_invite,
        icon: 'person_add',
        route: `/invite`,
        internal: true,
      },
      {
        name: menu_label_tou,
        icon: 'how_to_reg',
        route: `${settings.api_host}/tou/merchant/${merchant_uuid}.html`,
        target: '_blank',
      },
      {
        name: menu_label_switch_service,
        icon: 'transfer_within_a_station',
        route: '/switch-service',
        internal: true,
      },
      {
        name: menu_label_logout,
        icon: 'exit_to_app',
        route: '/logout',
        internal: true,
      },
    ];
    worker_menu_items = [
      { name: menu_label_home, icon: 'home', route: '/home', internal: true },
      {
        name: menu_label_orders,
        icon: 'file_copy',
        route: '/orders',
        internal: true,
      },
      {
        name: menu_label_chat,
        icon: 'chat_bubble',
        route: '/chats',
        internal: true,
      },
      {
        name: menu_label_payment_methods,
        icon: 'payment',
        route: '/cards',
        internal: true,
      },

      {
        name: 'menu_section_line',
      },

      {
        name: menu_label_settings,
        icon: 'settings',
        route: '/settings',
        internal: true,
      },
      {
        name: menu_label_public_profile,
        icon: 'person',
        route: '/profile',
        internal: true,
      },
      {
        name: menu_label_cv,
        icon: 'art_track',
        route: cv_url,
        id: 'cv-link',
      },
      {
        name: menu_label_my_teams,
        icon: 'people_alt',
        route: '/worker-teams',
        internal: true,
      },
      {
        name: menu_label_documents,
        icon: 'description',
        route: '/documents',
        internal: true,
      },

      {
        name: 'menu_section_line',
      },

      {
        name: menu_label_invite,
        icon: 'person_add',
        route: `/invite`,
        internal: true,
      },
      {
        name: menu_label_tou,
        icon: 'how_to_reg',
        route: `${settings.api_host}/tou/merchant/${merchant_uuid}.html`,
        target: '_blank',
      },
      {
        name: menu_label_switch_service,
        icon: 'transfer_within_a_station',
        route: '/switch-service',
        internal: true,
      },
      {
        name: menu_label_logout,
        icon: 'exit_to_app',
        route: '/logout',
        internal: true,
      },
    ];
  };

  let menu_admin_link = {
    admin: [
      {
        name: 'Admin',
        icon: 'beenhere',
        route: '/service-admin',
        target: '_blank',
      },
    ],
  };

  const get_username = () => {
    return !!$session.user.organization_name
      ? $session.user.organization_name
      : `${$session.user.first_name} ${$session.user.last_name}`;
  };

  const is_current_route = route => {
    return route === $session.route;
  };

  const set_active = (e, route) => {
    document.querySelectorAll('nav a.mdc-list-item').forEach(item => {
      item.classList.remove('mdc-list-item--activated');
    });
    e.target.classList.add('mdc-list-item--activated');
    session.write({ route: route });
  };

  const toggle_menu = () => {
    menu_opened = !menu_opened;
  };

  const switch_role = async () => {
    if (!button_disabled) {
      button_disabled = true;
      const new_role =
        $session.user.last_role === 'orderer' ? 'worker' : 'orderer';
      if (new_role === 'worker' && !$session.user.approved_worker) {
        show_message(t9n(TS.ERROR_NOT_APPROVED_WORKER), 'action');
      } else if (new_role === 'orderer' && !$session.user.approved_orderer) {
        show_message(t9n(TS.ERROR_NOT_APPROVED_ORDERER), 'action');
      } else {
        await APIClient.switch_role({ last_role: new_role });
        const user = $session.user;

        if (new_role === 'worker' && !user.is_worker) {
          router.navigate('/settings?first_time=true');
        } else if (new_role === 'orderer' && !user.is_orderer) {
          // return router.navigate('/settings?first_time=true');
          router.navigate('/settings?first_time=true');
        } else {
          router.navigate('/home');
        }

        if (new_role === 'worker')
          document.getElementById('basic-switch').value = true;
        if (new_role === 'orderer')
          document.getElementById('basic-switch').value = false;
      }
      button_disabled = false;
    }
  };

  const set_role = async e => {
    await APIClient.switch_role({ last_role: e.detail.role });
    document.removeEventListener('wp.roleswitcher.firstrole', async e => {
      await set_role(e);
    });
    // window.location.reload();
  };

  const ensure_role_class_on_body = role => {
    let other = role === 'orderer' ? 'worker' : 'orderer';
    let classes = document.body.classList;

    classes.remove(other);
    classes.add(role);
  };

  const create_cv_is_not_allowed_dialog = () => {
    let target = document.querySelector('.layout-dialog');

    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'cv-sharing-not-allowed',
        title: cv_sharing_not_allowed_title,
        content: cv_sharing_not_allowed_message,
        buttons: [
          {
            label: ok_button,
            action: () => {
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });

    dialog.open();
    return dialog;
  };

  const handle_cv_click = e => {
    e.preventDefault();
    if ($session.user.cv_is_public) {
      return router.navigate(cv_url);
    } else {
      return create_cv_is_not_allowed_dialog();
    }
  };

  const merchant_specific_words = word => {
    if ($session.merchant) {
      let i = word === 'worker' ? 0 : 1;
      if (
        $session.merchant.translations[i].localized_names[$session.language] !=
          null &&
        $session.merchant.translations[i].localized_names[$session.language] !==
          ''
      ) {
        window['' + word] =
          '(' +
          $session.merchant.translations[i].localized_names[$session.language] +
          ')';
        return (
          '(' +
          $session.merchant.translations[i].localized_names[$session.language] +
          ')'
        );
      } else {
        window['' + word] = '';
        return '';
      }
    }
  };

  const get_user_access_level = () => {
    if ($session.user.permission_type !== 'user') return true;
  };

  function handle_tooltip(event, text, id) {
    if (menu_opened === false) {
      let aside_id = document.querySelector('#aside_tooltips');
      let new_tooltip = document.createElement('div');
      new_tooltip.style.position = 'absolute';
      new_tooltip.style.top = event.clientY + 'px';
      new_tooltip.innerHTML = text;
      new_tooltip.style.zIndex = 999;
      // new_tooltip.setAttribute('data-tooltip', text)
      new_tooltip.classList.add('md-tooltip', 'md-tooltip--right', 'md-' + id);
      aside_id.appendChild(new_tooltip);
      setTimeout(function() {
        new_tooltip.style.transform = 'scale(1)';
      }, 111);
    }
  }

  function remove_tooltip(tooltip) {
    let aside_id = document.querySelector('#aside_tooltips');
    let to_delete = aside_id.querySelector('.md-' + tooltip);
    if (to_delete) {
      to_delete.remove();
    }
  }

  // reactive functions ------------------------------------------------------- //

  $: if (!!$session) {
    if (!!$session.user && $session.user.stats) {
      username = get_username();
      is_admin = get_user_access_level();
      merchant_uuid = $session.user.merchant_uuid;
      // avatar = `${settings.api_host}${$session.user.image_url}`;
      cv_url = `/cv/${$session.user.id}`;
      let link = document.querySelector('[href="/cv"]');
      if (!!link) link.href = cv_url;
      // unread_chat_count = $session.user.stats.unread_chats;
    }
    translate_texts();
  }

  $: if (!!settings && $session.user && $session.user.image_url) {
    avatar = `${settings.api_host}${$session.user.image_url}`;
  }

  $: 'last_role' in $session.user &&
    ensure_role_class_on_body($session.user.last_role);

  // initialization ----------------------------------------------------------- //

  const init_auth_layout = () => {
    // const drawer = MDCDrawer.attachTo(document.querySelector('.mdc-drawer'));
    const topAppBar = MDCTopAppBar.attachTo(document.getElementById('app-bar'));
    const mainContentEl = document.getElementById('main-content');
    topAppBar.setScrollTarget(mainContentEl);
    const cv_link = document.querySelector('#cv-link');
    document.addEventListener('wp.roleswitcher.firstrole', async e => {
      await set_role(e);
    });
    document
      .getElementById('role-switcher-switch')
      .addEventListener('click', async () => {
        await switch_role();
      });

    if (!!cv_link) {
      cv_link.addEventListener('click', handle_cv_click);
    }
    translate_texts();

    if (!!$session.user && $session.user.stats)
      chat_count.set($session.user.stats.unread_chats);
    has_init = true;
  };

  $: if (
    !!session &&
    !!session.branding &&
    !!session.branding.vars &&
    !!$session.branding.vars.powered_by_logo_url &&
    !is_powered_by
  ) {
    is_powered_by = true;
  }

  const change_branding = () => {
    let logo = `${settings.api_host}${$session.branding.vars.logo_url}`;
    document.getElementById(
      'logo-branding'
    ).style.backgroundImage = `url('${logo}')`;

    if ($session.user.last_role === 'orderer') {
      document.getElementById(
        'app-bar'
      ).style.background = `${$session.branding.vars.orderer_background_color}`;
      document.getElementById(
        'app-bar'
      ).style.color = `${$session.branding.vars.orderer_foreground_color}`;
      document.getElementById(
        'side_menu_btn'
      ).style.background = `${$session.branding.vars.orderer_background_color}`;
      document.getElementById(
        'side_menu_btn'
      ).style.color = `${$session.branding.vars.orderer_foreground_color}`;
      document.getElementById(
        'service-name'
      ).style.color = `${$session.branding.vars.orderer_foreground_color}`;
    } else {
      document.getElementById(
        'app-bar'
      ).style.background = `${$session.branding.vars.worker_background_color}`;
      document.getElementById(
        'app-bar'
      ).style.color = `${$session.branding.vars.worker_foreground_color}`;
      document.getElementById(
        'side_menu_btn'
      ).style.background = `${$session.branding.vars.worker_background_color}`;
      document.getElementById(
        'side_menu_btn'
      ).style.color = `${$session.branding.vars.worker_foreground_color}`;
      document.getElementById(
        'service-name'
      ).style.color = `${$session.branding.vars.worker_foreground_color}`;
    }
  };

  $: if ($session?.user?.last_role && $session?.branding?.vars && has_init) {
    change_branding();
  }

  $: if ($session?.branding?.vars && has_init) {
    change_branding();
  }

  onMount(() => init_auth_layout());
</script>

<div class="mdc-drawer-app-content {$session.user.last_role}">
  <SupportButton label={menu_label_support} />

  <GoogleAnalytics />

  <header class="mdc-top-app-bar mdc-top-app-bar__fixed app-bar" id="app-bar">
    <div class="mdc-top-app-bar__row">
      <section
        class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">

        <button
          data-cy="side-menu"
          style="border-radius: 50%; opacity: 1; content: ''; background-color:
          #FFFFFF33;"
          class="material-icons mdc-top-app-bar__navigation-icon mdc-icon-button
          minus-seven"
          id="side_menu_btn"
          on:click={() => toggle_menu()}>
          menu
        </button>

        <div style="width: 20px;" />

        <Notifications />

        <i class="avatar material-icons md-36 margin-right-5">
          {#if avatar}
            <img src={avatar} alt="avatar" />
          {:else}account_circle{/if}
        </i>
        <h1
          class="user-menu user-name mdc-typography--subtitle1 page-title
          color-white">
          {username}
        </h1>

        <a
          class="branding merchant-block"
          on:click={() => {
            router.navigate('/home');
          }}>
          <div
            id="logo-branding"
            class="mdc-top-app-bar__title logo-closed-orderer" />
          <!--{#if menu_opened === true}-->
          <div id="service-name">
            {#if !!$session.merchant}
              {$session.merchant.service.selection_name}
            {/if}
          </div>
          <!--{/if}-->
        </a>

        <h4
          class="mobile-role-worker mdc-typography--subtitle1"
          class:mobile-role-worker-hidden={menu_opened === true}
          class:mobile-role-worker-visible={menu_opened === false}>
          {#if $session.user.last_role === 'worker'}
            {menu_label_mode_worker}
          {:else}{menu_label_mode_orderer}{/if}
        </h4>

        <div class="role-switcher">
          <h4
            class="mdc-tab__text-label inline-block"
            class:mdc-typography--subtitle1={$session.user.last_role === 'worker'}>
            {menu_label_mode_orderer}
          </h4>

          <label class="inline-block label">
            <div id="role-switcher-switch" class="toggle">
              <input
                id="basic-switch"
                class="toggle-state"
                type="checkbox"
                name="check"
                disabled={true} />
              <div class="toggle-inner">
                <div
                  class="indicator"
                  class:toggle-state-checked={$session.user.last_role === 'worker'} />
              </div>
            </div>
          </label>

          <h4
            class="mdc-tab__text-label inline-block"
            class:mdc-typography--subtitle1={$session.user.last_role === 'orderer'}>
            {menu_label_mode_worker}
          </h4>
        </div>
      </section>
    </div>
  </header>

  <!-- Side menu -->

  <!--  class="mdc-drawer mdc-drawer&#45;&#45;dismissible"-->

  <aside
    id="side_menu"
    style="display: block; overflow-y: auto; overflow-x: hidden"
    class="mdc-drawer mdc-drawer--modal"
    class:menu-width-closed={menu_opened === false}
    class:anim-width={menu_opened === true}>
    <div
      style="overflow: visible;"
      class="mdc-drawer__content"
      class:icons-menu-closed={menu_opened === false}>
      <nav class="mdc-list">
        {#if $session.user.last_role === 'orderer'}
          {#each orderer_menu_items as menu}
            {#if menu.name === 'menu_section_line'}
              <hr
                style="margin-inline-start: 15px; margin-inline-end: 15px;
                opacity: .5;" />
            {:else}
              <a
                on:mouseover={() => handle_tooltip(event, menu.name, menu.icon)}
                on:mouseout={() => remove_tooltip(menu.icon)}
                id={menu.id}
                class="mdc-list-item"
                class:support={menu.is_support === true}
                class:support-opened={menu.is_support === true && menu_opened === true}
                class:support-closed={menu.is_support === true && menu_opened === false}
                class:mdc-list-item--activated={is_current_route(menu.route)}
                data-link={menu.internal}
                href={menu.route}
                on:click={e => {
                  set_active(e, menu.route);
                }}
                target={menu.target ? menu.target : '_self'}
                aria-selected="true"
                data-cy={menu.name}>

                {#if menu.icon === 'chat_bubble'}
                  <div>
                    <i
                      class="material-icons mdc-list-item__graphic"
                      aria-hidden="true">
                      {menu.icon}
                    </i>
                    <span
                      class="unread-chat-count-badge"
                      class:hidden-with-opacity={$chat_count === 0}>
                      {$chat_count}
                    </span>
                  </div>
                {:else}
                  <i
                    class="material-icons mdc-list-item__graphic"
                    aria-hidden="true">
                    {menu.icon}
                  </i>
                {/if}

                {#if menu_opened === true}
                  <span class="fade-in mdc-list-item__text">{menu.name}</span>
                {/if}

              </a>
            {/if}
          {/each}
        {/if}
        {#if $session.user.last_role === 'worker'}
          {#each worker_menu_items as menu}
            {#if menu.name === 'menu_section_line'}
              <hr
                style="margin-inline-start: 15px; margin-inline-end: 15px;
                opacity: .5;" />
            {:else}
              <a
                on:mouseover={() => handle_tooltip(event, menu.name, menu.icon)}
                on:mouseout={() => remove_tooltip(menu.icon)}
                id={menu.id}
                class="mdc-list-item"
                class:support={menu.is_support === true}
                class:support-opened={menu.is_support === true && menu_opened === true}
                class:support-closed={menu.is_support === true && menu_opened === false}
                class:mdc-list-item--activated={is_current_route(menu.route)}
                data-link={menu.internal}
                href={menu.route}
                on:click={e => {
                  set_active(e, menu.route);
                }}
                target={menu.target ? menu.target : '_self'}
                aria-selected="true"
                data-cy={menu.name}>

                {#if menu.icon === 'chat_bubble'}
                  <div>
                    <i
                      class="material-icons mdc-list-item__graphic"
                      aria-hidden="true">
                      {menu.icon}
                    </i>
                    <span
                      class="unread-chat-count-badge"
                      class:hidden-with-opacity={$chat_count === 0}>
                      {$chat_count}
                    </span>
                  </div>
                {:else}
                  <i
                    class="material-icons mdc-list-item__graphic"
                    aria-hidden="true">
                    {menu.icon}
                  </i>
                {/if}

                {#if menu_opened === true}
                  <span class="fade-in mdc-list-item__text">{menu.name}</span>
                {/if}

              </a>
            {/if}
          {/each}
        {/if}

        <!-- Admin link -->
        {#if is_admin}
          <a
            id={'admin_id'}
            class="mdc-list-item"
            class:support={menu_admin_link.admin[0].is_support === true}
            class:support-opened={menu_admin_link.admin[0].is_support === true && menu_opened === true}
            class:support-closed={menu_admin_link.admin[0].is_support === true && menu_opened === false}
            data-link={menu_admin_link.admin[0].internal}
            href={`${window.location.origin}/service-admin`}
            on:mouseover={() => handle_tooltip(event, 'Admin', 'admin')}
            on:mouseout={() => remove_tooltip('admin')}
            on:click={set_active}
            target={menu_admin_link.admin[0].target ? menu_admin_link.admin[0].target : '_self'}
            aria-selected="true"
            data-cy={menu_admin_link.admin[0].name}>
            <i
              class="material-icons mdc-list-item__graphic
              mdc-list-item__graphic"
              aria-hidden="true">
              {menu_admin_link.admin[0].icon}
            </i>
            {#if menu_opened === true}
              <span class="fade-in mdc-list-item__text">
                {menu_admin_link.admin[0].name}
              </span>
            {/if}
          </a>
        {/if}

        <!-- Powered by -->
        {#if is_powered_by}
          <a
            href="https://www.workpilots.com"
            target="_blank"
            class="mdc-list-item powered-by">
            <img
              src="/assets/powered_by.png"
              alt="
              "
              class="logo fade-in"
              style="margin-left: 5px; position: absolute; margin-bottom: 15px;"
              width="50" />
            <span
              style="margin-left: 71px; position: absolute; font-family: Roboto,
              sans-serif; font-size: .875rem; line-height: 1.375rem;
              font-weight: 500; letter-spacing: .0071428571em; text-transform:
              inherit;"
              class="powered-by fade-in mdc-list-item__text">
              WorkPilots
            </span>
          </a>
        {/if}
      </nav>

    </div>
  </aside>

  <main
    class="main-content"
    id="main-content"
    class:hide-scrollbar={hide_scrollbar === true}>
    <div class="mdc-top-app-bar--fixed-adjust">
      <slot name="content">
        <h1>{no_content}</h1>
      </slot>
    </div>

    <div class="layout-dialog" />

    <Messages />

  </main>
</div>

<style>
  body {
    display: flex;
    height: 100vh;
    overflow-y: scroll;
  }

  /* MDC switch replacement */

  .label {
    display: inline-flex;
    align-items: center;
    cursor: pointer;
  }

  .toggle {
    isolation: isolate;
    position: relative;
    height: 13px;
    width: 40px;
    border-radius: 12px;
    background: #00000066;
    /* overflow: hidden; */
  }

  .toggle-inner {
    z-index: 2;
    position: absolute;
    top: -4px;
    left: 1px;
    height: 20px;
    width: 40px;
    border-radius: 12px;
    overflow: hidden;
  }

  .toggle-state {
    display: none;
  }

  .indicator {
    height: 100%;
    width: 200%;
    background: white;
    border-radius: 12px;
    transform: translate3d(-75%, 0, 0);
    transition: transform 0.35s cubic-bezier(0.85, 0.05, 0.18, 1.35);
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }

  .toggle-state:checked ~ .active-bg {
    transform: translate3d(-50%, 0, 0);
  }

  .toggle-state:checked ~ .toggle-inner .indicator {
    transform: translate3d(25%, 0, 0);
  }

  .toggle-state-checked {
    transform: translate3d(25%, 0, 0);
  }

  /* Powered by  */

  .powered-by {
    margin-left: -8px;
  }

  .mdc-top-app-bar__row {
    height: 54px;
  }

  .mdc-drawer {
    background: #333;
  }

  .mdc-list-item__graphic,
  .mdc-list-item__text {
    color: white;
  }

  .mdc-list-item:hover {
    background: var(--list-item-color);
  }

  .mdc-list-item:hover .mdc-list-item__graphic,
  .mdc-list-item:hover .mdc-list-item__text {
    color: #14557a;
  }

  .mdc-list-item--activated {
    background: var(--list-item-color);
  }

  .mdc-list-item--activated .mdc-list-item__graphic,
  .mdc-list-item--activated .mdc-list-item__text {
    color: #14557a;
  }

  .mdc-drawer-app-content {
    flex: auto;
    overflow: auto;
    position: relative;
  }

  .mdc-top-app-bar--fixed-adjust {
    height: 100%;
    padding-top: 54px;
  }

  .mdc-list {
    padding-top: 80px;
  }

  .main-content {
    overflow: auto;
    height: 100%;
  }

  .app-bar {
    position: fixed;
    top: 0;
    left: 0;
  }

  .mdc-top-app-bar {
    z-index: 7;
    -webkit-box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.14);
    -moz-box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.14);
    box-shadow: 0 4px 8px 3px rgba(0, 0, 0, 0.14);
  }

  .minus-seven {
    margin-left: -7px;
  }

  #logo-branding {
    width: 40px;
    height: 38px;
    margin-top: 4.5px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    transition: all 0.3s ease;
  }

  #app-bar,
  #side_menu_btn {
    transition: all 0.3s ease;
  }

  .menu-button {
    /*position: relative;*/
    margin-left: 0px;
  }

  .avatar img {
    width: 36px;
    height: 36px;
  }

  .user-menu {
    margin-left: 0px;
  }

  .user-menu i {
    position: relative;
    top: 5px;
  }

  .role-switcher {
    display: inline-block;
    position: absolute;
    right: 0px;
    /*width: 320px;*/ /* fix for issue #853 */
    padding: 0px;
  }

  .role-switcher h4 {
    margin: 0 10px;
  }

  .orderer .mdc-switch__thumb {
    border-color: var(--orderer-foreground-color);
    background-color: var(--orderer-foreground-color);
  }

  .worker .mdc-switch__thumb {
    border-color: var(--worker-foreground-color);
    background-color: var(--worker-foreground-color);
  }

  .margin-right-5 {
    margin-right: 5px;
    /*margin-left: 30px;*/
  }

  .inline-block {
    display: inline-block;
    margin-bottom: -1px;
  }

  .material-icons.md-18 {
    font-size: 18px;
  }

  .material-icons.md-24 {
    font-size: 24px;
  }

  .material-icons.md-36 {
    font-size: 36px;
  }

  .material-icons.md-48 {
    font-size: 48px;
  }

  .light {
    font-weight: 300 !important;
  }

  .mdc-top-app-bar .avatar img {
    width: 36px;
    border-radius: 50%;
  }

  .merchant-block {
    position: relative;
    margin-left: auto;
    margin-right: auto;
    left: -130px;
    cursor: pointer;
  }

  a {
    cursor: pointer;
  }

  .branding,
  #logo-branding,
  #service-name {
    display: inline-block;
  }

  #service-name {
    display: inline-block;
    font-size: 1em;
    text-decoration: none;
    position: relative;
    transition: all 0.3s ease;
    top: -14px;
    /*left: -5px;*/
  }

  .user-name {
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 40ch;
  }

  a:link {
    text-decoration: none !important;
  }

  .hide-scrollbar {
    overflow-y: hidden;
  }

  .icons-menu-closed {
    width: 60px;
  }

  .menu-width-closed {
    width: 60px;
  }

  .support {
    background-color: var(--mdc-theme-primary);
    position: absolute;
    bottom: 10px;
  }

  .support:hover {
    color: white;
    background-color: var(--mdc-theme-secondary);
  }

  .support-closed {
    width: 25px;
  }

  .support-opened {
    width: 222px;
  }

  .mobile-role-worker {
    display: none;
  }

  .unread-chat-count-badge {
    margin-top: -26px;
    display: block;
    position: relative;
    min-width: 17px;
    top: -8px;
    left: 14px;
    background-color: red;
    color: white;
    border-radius: 50%;

    width: 17px;
    height: 17px;
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    padding: 0;
    overflow: hidden;
    line-height: 20px;
  }

  .hidden-with-opacity {
    opacity: 0;
  }

  /* Tablet Mode
    *******************************************************/
  @media (max-width: 900px) {
    .user-menu {
      display: none;
    }

    .user-name {
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 16ch;
    }
  }

  /* Mobile Mode
    *******************************************************/

  @media (min-width: 0) and (max-width: 768px) {
    #zendesk_support {
      display: none;
    }

    .role-switcher {
      display: inline-block;
      position: absolute;
      right: 50px;
      width: 0px;
      padding: 0px;
    }

    .mdc-drawer {
      background: rgba(51, 51, 51, 0.98);
      width: fit-content;
    }

    .role-switcher h4 {
      display: none;
    }

    .mobile-role-worker {
      align-items: center;
      position: absolute;
      right: 61px;
      font-size: 13px;
      font-weight: bold;
      color: #ffffff;
      bottom: 0;
      top: 0;
    }

    .mobile-role-worker-hidden {
      display: none;
    }

    .mobile-role-worker-visible {
      display: flex;
    }

    .margin-right-5 {
      margin-right: 5px;
      margin-left: -16px;
    }

    .user-menu {
      display: none;
    }

    #service-name {
      display: none;
    }

    .merchant-block {
      left: -66px;
    }

    .hide-scrollbar {
      overflow-y: scroll;
    }

    .mdc-drawer__content::-webkit-scrollbar {
      width: 0px;
    }
  }

  /*!* Powered by logo*/
  /********************************************************!*/
  /*@media (max-height: 715px) {*/
  /*  .powered-by {*/
  /*    display: none;*/
  /*  }*/
  /*}*/
</style>
